import React from "react";
import { useSiteData } from "../../context/SiteDataContext";
import { Shield, Users, Flame, Zap, Megaphone, Coins } from "lucide-react";

const iconMap = { Shield, Users, Flame, Zap, Megaphone, Coins };

const FeatureCard = ({ feature, index }) => {
  const IconComp = iconMap[feature.icon] || Shield;
  return (
    <div className="group relative bg-[#0d1a0d]/80 border border-[#1a3a1a] rounded-xl p-6 hover:border-yellow-400/40 transition-all duration-500 hover:-translate-y-1">
      <div className="absolute inset-0 bg-gradient-to-b from-yellow-400/5 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      <div className="relative">
        <div className="w-12 h-12 rounded-lg bg-yellow-400/10 border border-yellow-400/20 flex items-center justify-center mb-4 group-hover:bg-yellow-400/20 transition-colors duration-300">
          <IconComp size={22} className="text-yellow-400" />
        </div>
        <h3 className="text-white font-bold text-lg mb-2">{feature.title}</h3>
        <p className="text-gray-400 text-sm leading-relaxed">{feature.description}</p>
      </div>
    </div>
  );
};

const FeaturesSection = () => {
  const { content, siteConfig } = useSiteData();
  const features = content?.features || [];
  const logoUrl = siteConfig?.logoUrl || "/marsu.png";
  const leftFeatures = features.slice(0, 3);
  const rightFeatures = features.slice(3, 6);

  return (
    <section id="features" className="relative py-20 overflow-hidden">
      <div className="absolute inset-0 bg-[#060d06]" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-yellow-600/3 rounded-full blur-[150px]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-center mb-16">
          <span className="text-yellow-400">MARSUPILAMI</span>{" "}
          <span className="text-white">FEATURES</span>
        </h2>
        <div className="flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 flex flex-col gap-5">
            {leftFeatures.map((f, i) => (<FeatureCard key={i} feature={f} index={i} />))}
          </div>
          <div className="hidden lg:flex flex-shrink-0 items-center justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-yellow-400/10 rounded-full blur-[60px] scale-125" />
              <img src={logoUrl} alt="Marsupilami" className="relative w-48 h-48 object-contain animate-hero-float" />
            </div>
          </div>
          <div className="flex-1 flex flex-col gap-5">
            {rightFeatures.map((f, i) => (<FeatureCard key={i} feature={f} index={i + 3} />))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
